import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Row, Col, Breadcrumb, Pagination, Button, message ,Tabs, Spin} from 'antd';
import $ from '$'

// personal component
import Question from '@/entry_question_editor/question/question_view/view';
import DeteteRelative from './modal/delete_relative.js';
import UpdataRelative from './modal/updata_relative.js';
import NewTree from './component/new_tree.js';
import { setStageAPI, getSuperClassQuestionListAPI, getSuperClassTreeListAPI, getTreeListAPI, getSuperClassQuestionFilterAPI } from '@/API'
import { NUM_TO_TYPE } from '@/utils/questionType.js';
import '@/css/check_beyond_level.less';

const TabPane = Tabs.TabPane;
// 常量
let task_id = '';
class CheckBeyondLevelDetail extends Component{

	static contextTypes = {
	    router: React.PropTypes.object.isRequired,
	    dispatch: React.PropTypes.func.isRequired
	}
	
	constructor(props) {
	    super(props);
	    this.state = {
		    	page: 1, // 当前页数
		    	pageSize: 10, //每页显示条数
		    	total: 0, // 总数据个数
		    	isShowDeleteModal: false, // 是否显示删除关联关系modal
		    	isShowUpdataModal: false, // 是否显示更改关联关系modal
		    	toggleShow: true, // 收起章节-默认展开
		    	source_type: '', // 来源（type）
		    	oldTreeId: '', // 当前章节树id
		    	newTreeId: '', // 新的章节树id
		    	currentQuestionId: '', // 当前的题目id
		    	assist_id: '', // 教辅id
		    	list: [], // 题目列表
		    	treeList: [], // 章节树列表
	    		relativeList: [], // 关联树列表，
				currentTab:'-1', // 
				knowledge_list: [], // 知识点列表
				know_id: '', // 知识点id
				question_count: { // 题目数量列表
					all: 0, // question_count
					del: 0, // question_del_count
					modify: 0, // question_modify_count
				},
				loading: false,
	    }
	}

	componentWillMount() {
		task_id = this.context.router.route.match.params[0];
		this.getTreeList({task_id}, res => {
			const relativeList = res.data.list;
			const source_type = res.data.source_type;
			this.setState({relativeList, source_type});
			if (+source_type === 26) { // 知识点
				this.getKnowledgeTreeList({
					type: '26',
				}, (resData) => {
					const treeList = resData.data.list
					this.setState({treeList});
				}, (errData) => {
					console.log(errData);
					this.setState({treeList: []});
				})
			}
			
		}, err => {
			console.log(err)
			this.setState({relativeList: []});
		});
	}

	// 更改题目状态
	setStage = (data, sucCall, errCall) => {
		setStageAPI(data).then((sucData) => {
			console.log(sucData);
			sucCall && sucCall(sucData);
		}).catch((err) => {
			console.log(err)
			errCall && errCall(err)
		})
	}

	// 获取知识点章节树
	getKnowledgeTreeList = (data, sucCall, errCall) => {
		getTreeListAPI(data).then(res => {
			sucCall && sucCall(res);
		}).catch(err => {
			errCall && errCall(err)
		})
	}

	// 获取题目列表
	getquestionList = (data, sucCall, errCall) => {
		const { know_id, currentTab } = this.state;
		let relativeData = Object.assign({
			know_id,
			tab_type: currentTab,
		}, data);
		getSuperClassQuestionListAPI(relativeData).then((sucData) => {
			let listNum = sucData.data;
			let question_count = {
				all: listNum.question_count,
				del: listNum.question_del_count,
				modify: listNum.question_modify_count,
			}
			this.setState({question_count});
			sucCall && sucCall(sucData);
		}).catch((err) => {
			errCall && errCall(err)
		})
	}

	// 获取知识点列表
	getquestionKnowledgeList = (data, sucCall, errCall) => {
		const { currentTab, oldTreeId } = this.state;
		let relativeData = Object.assign({
			tree_id: oldTreeId,
			task_id,
			tab_type: currentTab,
		}, data);
		
		getSuperClassQuestionFilterAPI(relativeData).then((sucData) => {
			sucCall && sucCall(sucData);
		}).catch((err) => {
			errCall && errCall(err)
		})
	}

	// 获取章节树列表
	getTreeList = (data, sucCall, errCall) => {
		getSuperClassTreeListAPI(data).then((sucData) => {
			// console.log(sucData);
			sucCall && sucCall(sucData);
		}).catch((err) => {
			console.log(err)
			errCall && errCall(err)
		})
	}

	// 删除关联关系
	handleDeleteRelative = (id, taskStatus) => {
		if (+taskStatus === 1) {
			message.error('已入库，不可操作！');
			return;
		}
		this.setState({isShowDeleteModal: true, currentQuestionId: id})
	}

	// 确认删除关联关系
	handleDeleteOk = () => {
		const { oldTreeId, currentQuestionId, page, pageSize } = this.state;
		// const task_id = this.context.router.route.match.params[0];
		let data = {
			question_id: currentQuestionId,
			task_id,
			tree_id: oldTreeId,
			type: 2,
			new_tree: 0
		}
		let list_data = {
			page,
			pagesize: pageSize,
			tree_id: oldTreeId,
			task_id
		}

		// 删除接口
		if (oldTreeId) {
			this.setStage(data, () => {
				message.success('删除关联关系成功～');
				this.getquestionList(list_data, res => { // 树节点存在
					const list = res.data.list;
					const total = res.data.total;
					this.setState({list, total});
				}, err => {
					console.log(err);
					this.setState({list: [], total: 0});
				});
			})
		}
		// 关闭modal-success
		this.handleDeleteCancel();
	}

	// 	取消删除关联关系
	handleDeleteCancel = () => {
		this.setState({isShowDeleteModal: false})
	}

	// 更新关联关系
	handleUpdataRelative = (id, assist_id, taskStatus) => {
		const { source_type } = this.state;
		if (+taskStatus === 1) {
			message.error('已入库，不可操作！');
			return;
		}
		if (+source_type === 1) {
			const data = {
				type: 101,
				rootId: assist_id
			}
			this.getKnowledgeTreeList(data, (resData) => {
				const treeList = resData.data.list
				this.setState({treeList});
			}, (errData) => {
				console.log(errData);
				this.setState({treeList: []});
			})
		}
		this.setState({isShowUpdataModal: true, currentQuestionId: id, assist_id});
	}

	// 确认更新关联关系
	handleUpdataOk = () => {
		const { oldTreeId, newTreeId, currentQuestionId, page, pageSize } = this.state;
		// const task_id = this.context.router.route.match.params[0];
		// console.log(oldTreeId,'|', newTreeId)

		let data = {
			question_id: currentQuestionId,
			task_id,
			tree_id: oldTreeId,
			type: 3,
			new_tree: newTreeId
		}

		let list_data = {
			page,
			pagesize: pageSize,
			tree_id: oldTreeId,
			task_id
		}
		
		// 更新关联关系接口
		if (oldTreeId) {
			this.setStage(data, (listData) => { // 成功
				message.success('更新关联关系成功～')
				this.getquestionList(list_data, res => { // 树节点存在
					const list = res.data.list;
					const total = res.data.total;
					this.setState({list, total})
				}, err => {
					console.log(err);
					this.setState({list: [], total: 0});
				});
			},(err) => { // 失败
				console.log(err)
			})
		}
		
		// 关闭modal-success
		this.handleUpdataCancel();
	}

	// 	取消更新关联关系
	handleUpdataCancel = () => {
		this.setState({isShowUpdataModal: false})
	}

	// 修改题目
	handleModifyQuestion = (type, id, taskStatus) => {
		if (+taskStatus === 1) {
			message.error('已入库，不可操作！');
			return;
		}
		let url = `${window.location.origin}/question.html#/questionmanage/${type}/${id}`;
		window.open(url)
	}

	// 切换显示章节
	handleToggle = () => {
		let { toggleShow } = this.state;
		this.setState({toggleShow: !toggleShow});
	}

	// 页码发生变化
	onPageChange = (page, pagesize) => {
		const { oldTreeId } = this.state;
		// const task_id = this.context.router.route.match.params[0];

		const list_data = {
			page,
			pagesize,
			tree_id: oldTreeId,
			task_id
		}
		
		// 获取题目列表
		this.getquestionList(list_data, res => {
			const list = res.data.list;
			const total = res.data.total;
			this.setState({list, total})
			$('html').scrollTop(0)
		}, err => {
			console.log(err);
			this.setState({list: [], total: 0});
		});	
		this.setState({page})
	}
	// 每页的条数发生变化
	onPageSizeChange = (page, pagesize) => {
		const { oldTreeId } = this.state;
		// const task_id = this.context.router.route.match.params[0];

		const list_data = {
			page,
			pagesize,
			tree_id: oldTreeId,
			task_id
		}
		
		// 获取题目列表
		this.getquestionList(list_data, res => {
			const list = res.data.list;
			const total = res.data.total;
			this.setState({list, total})
		}, err => {
			console.log(err);
			this.setState({list: [], total: 0});
		});
		this.setState({pageSize: pagesize})
	}

	// 折叠框
	onChapterSelect = (selectedKeys, other) => {
		let { pageSize, relativeList } = this.state;
		const tree_id = selectedKeys[0] ? selectedKeys[0] : '';
		// const task_id = this.context.router.route.match.params[0];
		let data = {
			page:1,
			pagesize: pageSize,
			tree_id,
			task_id
		}
		
		if (tree_id && tree_id.length > 0 ) { // 树节点存在
			this.getquestionList(data, res => {
				const list = res.data.list;
				const total = res.data.total;
				this.setState({list, total})
			}, err => {
				console.log(err);
				this.setState({list: [], total: 0});
			});
			this.getquestionKnowledgeList({
				tree_id,
				tab_type: '-1'
			}, res => {
				const knowledge_list = res.data.knowledge_list;
				this.setState({knowledge_list});
			}, err => {
				console.log(err);
			});	
		}

		this.setState({oldTreeId: tree_id, page:1, currentTab: '-1', know_id: ''});
	}

	// 选择章节树
	onRelativeSelect = (selectedKeys, other) => {
		let newTreeId = selectedKeys[0] ? selectedKeys[0] : '';
		this.setState({ newTreeId })
	}

	// tab切换
	onTabChange=(val)=>{
		const {page, pageSize, oldTreeId} = this.state;
		let list_data = {
			page: 1,
			pagesize: pageSize,
			tree_id: oldTreeId,
			task_id,
			tab_type: val,
			know_id: '',
		}
		this.setState({loading: true});
		this.getquestionList(list_data, res => { // 树节点存在
			const list = res.data.list;
			const total = res.data.total;
			this.setState({list, total, loading: false})
		}, err => {
			console.log(err);
			this.setState({list: [], total: 0, loading: false});
		});
		this.getquestionKnowledgeList({
			tree_id: oldTreeId,
			tab_type: val,
		}, res => {
			const knowledge_list = res.data.knowledge_list;
			this.setState({knowledge_list});
		}, err => {
			console.log(err);
		});
		this.setState({currentTab: val, know_id: '', page: 1});
	}

	// 切换知识点
	onClickKnowledge = know_id => {
		if(know_id==this.state.know_id){
			know_id=''
		}
		const {page, pageSize, oldTreeId, currentTab} = this.state;
		
		let list_data = {
			page,
			pagesize: pageSize,
			tree_id: oldTreeId,
			task_id,
			tab_type: currentTab,
			know_id,
		}
		this.setState({loading: true});
		this.getquestionList(list_data, res => { // 树节点存在
			const list = res.data.list;
			const total = res.data.total;
			this.setState({list, total, loading: false})
		}, err => {
			console.log(err);
			this.setState({list: [], total: 0, loading: false});
		});
		this.setState({know_id});
	}

	// 

	// 章节树
	dataTreeMap = (treeList, num) => {
		let treeListNew = [];
		treeList.length > 0 && treeList.forEach(item => {
			let insideItem = item;
			let level1 = {
				key: insideItem.id,
				title: num && (!insideItem.list || (insideItem.list && insideItem.list.length < 1)) ? `${insideItem.name}( ${insideItem.question_count} / ${insideItem.question_count_del_relate} / ${insideItem.question_count_move} )` : insideItem.name,
			}

			let loop = (parentData, data) => {
				let child = [];
				data.forEach(insideChild => {
					let levelEach = {
						key: insideChild.id,
						title: num && (!insideChild.list || (insideChild.list && insideChild.list.length < 1)) ? `${insideChild.name}( ${insideChild.question_count} / ${insideChild.question_count_del_relate} / ${insideChild.question_count_move} )` : insideChild.name,
					}
					if (insideChild.list && insideChild.list.length > 0) {
						loop(levelEach, insideChild.list);
					}

					child.push(levelEach);
				});
				parentData.children = child;
			}
			if (insideItem.list && insideItem.list.length > 0) {
				loop(level1, insideItem.list);
			}
			treeListNew.push(level1);
		});
		return treeListNew;
	}
	// 按钮
	renderButton = (type, id, assist_id, newRelate, taskStatus, relative_type) => {
		let typeName = NUM_TO_TYPE[type];
		let newRelative = newRelate && newRelate.length > 0 && +relative_type === 3 ? true : false; 
		// taskStatus = 1 // 已入库
		return (
			<div className="superclass-button-group">
				{/*<Button type="primary">通过</Button>*/}
				<Button 
					type={+relative_type === 2 ? 'primary' : 'default'}
					onClick={() => this.handleDeleteRelative(id, taskStatus)}>删除关联关系</Button>
				<Button 
					type={+relative_type === 3 ? 'primary' : 'default'}
					onClick={() => this.handleUpdataRelative(id, assist_id, taskStatus)}>更改关联关系</Button>
				<p className={newRelative ? 'new-relative' : ''}>
					{ newRelative ? `新关联：${newRelate}` : '' }
				</p>
				<Button type="default"
					onClick={() => this.handleModifyQuestion(typeName, id, taskStatus)}>修改题目</Button>
			</div>
		)
	}

	// 折叠框
	renderFold = () => {
		const { relativeList, toggleShow } = this.state;
		const dataList = this.dataTreeMap(relativeList, 'showNum');
		
		return (
			<div className={`superclass-fold-container clearfix ${toggleShow ? '' : 'hidden-chapter'}`}>
				<div className="superclass-fold">
					<NewTree
						showLine={true}
				        onSelect={this.onChapterSelect}
				        list={dataList} />
				</div>
				<p className="toggle-button" onClick={this.handleToggle}>{toggleShow ? '收起章节' : '展开章节'}</p>
			</div>
		)
	}
	renderQuestion=()=>{
		let { list, page, pageSize, loading, question_count } = this.state;
		let questionList=list && list.length > 0 ?list.map((item, index) =>
			<div  className="checkout-superclass-list" key={index}>
				{/*内容*/}
				<Question className="checkout-superclass-qustion" isChapter={true} showRelative={true} data={item} num={(page-1)*pageSize+index} />
				{/*按钮*/}
				{
					this.renderButton(item.type_show, item.question_id, item.assist_id, item.new_relate, item.task_online_status, item.type)
				}
			</div>
		):<p className="without-title">暂无题目</p>
	
			return(
				<div>
					<Tabs defaultActiveKey="1" type="card"  onChange={this.onTabChange}>
						<TabPane tab={`全部(${question_count.all})`} key="-1"></TabPane>
						<TabPane tab={`删除关联(${question_count.del})`} key="2"></TabPane>
						<TabPane tab={`修改关联(${question_count.modify})`} key="3"></TabPane>
					</Tabs>
					<Spin spinning={loading}>
						{questionList}
					</Spin>
				</div>
			)	
	}

	render() {
		const { page, pageSize, total, list, isShowDeleteModal, isShowUpdataModal, treeList, knowledge_list, know_id } = this.state;
		const treeData = this.dataTreeMap(treeList);

		return (
			<div className="checkout-superclass">
				<Row gutter={40} type="flex" align="middle">
					<Col span={8}>
						<Breadcrumb className="bread-crumb">
		                    <Breadcrumb.Item  className="breadItem" ><span>题目管理</span></Breadcrumb.Item>
		                    <Breadcrumb.Item className="breadItem"><Link to="/questionmanage/checkBeyondLevel">查超纲</Link></Breadcrumb.Item>
		                    <Breadcrumb.Item className="breadItem"><span>{`任务详情(${task_id})`}</span></Breadcrumb.Item> 
		                </Breadcrumb>
	                </Col>
	                <Col span={16}>
	                </Col>
				</Row>
				<div className="knowledge-list">
				{
					knowledge_list.length > 0 && 
					<Row className="knowledge-list-row" type="flex" align="middle">
						<Col className="knowledge-pointer">知识点：</Col>
						<Col className="knowledge-pointer-list">
							{
								knowledge_list.map((item, index) => 
									<span className={item.know_id === know_id && !item.is_relate ? 'curent-know-points relate-red' : (item.know_id !== know_id && !item.is_relate ? 'relate-red' : (item.know_id === know_id && !!item.is_relate ? 'curent-know-points' : '')) }  key={index} onClick={() => this.onClickKnowledge(item.know_id)}>{`${item.name}(${item.count})`}</span>
								)
							}
						</Col>
					</Row>
				}
				</div>
				<div className="checkout-superclass-container">
					{this.renderQuestion()}
					{this.renderFold()}
				</div>
				<div className="page-list">
					{
						+total > 0 ? 
							<Pagination 
								showQuickJumper
								showSizeChanger
								defaultPageSize={pageSize}
								current={page} 
								total={total} 
								onChange={this.onPageChange}
								onShowSizeChange={this.onPageSizeChange} /> : null
					}
				</div>
				<DeteteRelative 
					isShowDeleteModal={isShowDeleteModal}
					onOk={this.handleDeleteOk}
					onCancel={this.handleDeleteCancel}/>
				<UpdataRelative 
					isShowUpdataModal={isShowUpdataModal}
					list={treeData}
					onUpdataSelect={this.onRelativeSelect}
					onOk={this.handleUpdataOk}
					onCancel={this.handleUpdataCancel}/>
			</div>
		)
	}

}

export default connect(null, null)(CheckBeyondLevelDetail);



// WEBPACK FOOTER //
// ./src/entry_app/question_manage/check_beyond_level/check_beyond_level_detail.js